import React from "react"
import ComingSoon from "../../../../imgs/courses/coming_soon.svg"
import { Grid, Typography, makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  imageContainer: {
    height: "100%",
    width: "100%",
  },
  image: {
    height: 200,
    [theme.breakpoints.up("md")]: {
      height: 400,
    },
  },
}))


export default function ShowComingSoon() {
  const classes = useStyles()

  return <Grid container direction={"column"}>
    <Grid container item justify={"center"} className={classes.imageContainer}>
      <img alt="Coming Soon" src={ComingSoon} className={classes.image} loading={"lazy"}/>
    </Grid>
    <Grid item>
      <Typography align={"center"} variant={"h6"}>
        Coming Soon!
      </Typography>
    </Grid>
    <Grid item>
      <Typography align={"center"} variant={"subtitle1"}>
        We are working hard giving final touches to the course. This section will update shortly.
      </Typography>
    </Grid>
  </Grid>
}